import React, { useEffect } from 'react';
import './new.css';
import { Link } from 'react-router-dom';
import NavBar from '../components/Nav';
import Footer from '../components/footer';
import ScrollTop from '../components/Scrolltop';
import Whatsapp from '../components/Whatsapp';
import Cosection from '../components/Cosections';

export const Federal = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <NavBar />
      <div className="tax-page">
        <div className="tax-notification-container">
          <div className="tax-notification">
            <div className="tax-notification-glow"></div>
            <div className="tax-notification-border-glow"></div>
            <h1 className="tax-notification-title">Federal and State Tax Filing (1040 Series)</h1>
            <Link to="/services" className="tax-notification-body">← Go Back to Services</Link>
          </div>
        </div>

        <div className="tax-content-container">
          <h1 className="tax-section-title">Federal and State Tax Filing Services</h1>
          <p className="tax-section-description">
            At <strong>Litax </strong>, we go beyond standard tax preparation—we deliver end-to-end solutions 
            for <strong>federal, state, city, and county tax filing</strong>. Whether you are an individual taxpayer, a 
            freelancer, or someone navigating multiple sources of income, our goal is to make your filing process 
            <em>stress-free, accurate, and 100% compliant</em>. We combine years of expertise, in-depth knowledge of U.S. 
            tax laws, and personalized attention to ensure you never miss out on opportunities to save money while 
            staying compliant with IRS and state authorities.
          </p>

          <h2 className="tax-subheading">Federal Tax Filing (1040 Series)</h2>
          <p className="tax-section-description">
            The <strong>Form 1040 series</strong> is the backbone of the federal tax system in the United States. 
            Every taxpayer, whether salaried, retired, or self-employed, interacts with these forms to report income, 
            claim deductions, calculate liabilities, and ensure compliance. Filing federal taxes correctly is crucial 
            because errors can lead to penalties, audits, or missed opportunities for refunds. Our tax professionals 
            specialize in handling all variations of the 1040 forms—no matter how simple or complex your financial 
            profile may be.
          </p>

          <h2 className="tax-subheading">Key 1040 Forms We Handle with Expertise:</h2>
          <ul>
            <li><strong>Form 1040:</strong> The standard U.S. Individual Income Tax Return, used by most taxpayers to 
            report earnings, deductions, credits, and calculate overall tax liability.</li>
            <li><strong>Form 1040-SR:</strong> Created specifically for senior citizens aged 65+, this form simplifies 
            filing with larger fonts, easy-to-follow layouts, and senior-friendly design.</li>
            <li><strong>Form 1040NR:</strong> Designed for <em>non-resident aliens</em> reporting U.S. income, this form 
            requires specialized attention to tax treaties and foreign income reporting rules.</li>
            <li><strong>Form 1040X:</strong> Essential for making corrections or amendments to previously filed federal 
            tax returns, ensuring accurate resubmission and compliance.</li>
            <li><strong>Form 1040-ES:</strong> Used by freelancers, gig workers, contractors, and self-employed individuals 
            to calculate and pay quarterly estimated taxes—preventing surprises at year-end.</li>
          </ul>

          <h2 className="tax-subheading">State Tax Filing Services</h2>
          <p className="tax-section-description">
            Each U.S. state has its own tax laws, filing rules, and deadlines. Some states impose income tax, while others 
            have unique systems of taxation. Our team provides <strong>state-specific tax filing services</strong> to ensure 
            complete compliance with the state(s) you live in, work in, or earn income from. We make the process seamless, 
            whether you’re filing in a single state or managing taxes across multiple jurisdictions.
          </p>
          <ul>
            <li>Accurate reporting of state-specific income, credits, and deductions.</li>
            <li>Compliance with filing deadlines and regulations unique to each state.</li>
            <li>Specialized services for individuals with multi-state income or residency.</li>
            <li>Strategic guidance on minimizing state tax liability while ensuring compliance.</li>
          </ul>

          <h2 className="tax-subheading">City and County Tax Returns</h2>
          <p className="tax-section-description">
            Did you know that some U.S. cities and counties also levy their own taxes? Filing local returns can be 
            confusing since requirements differ significantly across jurisdictions. At Litax , we help you 
            stay ahead of these obligations so you don’t face unexpected local penalties.
          </p>
          <ul>
            <li><strong>City Tax Returns:</strong> We handle filings for cities that impose municipal income tax 
            (e.g., in Ohio, Pennsylvania, Michigan), ensuring precise compliance with local codes.</li>
            <li><strong>County Tax Returns:</strong> Assistance with filing for property, income, or other 
            county-specific taxes as mandated by local government.</li>
          </ul>

          <h2 className="tax-subheading">Why Trust Litax ?</h2>
          <p className="tax-section-description">
            Choosing the right tax partner is critical for peace of mind and financial security. At Litax , 
            we pride ourselves on being more than just tax preparers—we are <strong>strategic partners in your financial journey</strong>.
          </p>
          <p className="tax-section-description">
            <strong>✔ Experienced Tax Experts:</strong> Our team is trained in the complexities of IRS regulations, 
            state laws, and local tax systems, giving you confidence that your returns are always handled accurately.
          </p>
          <p className="tax-section-description">
            <strong>✔ Tailored Solutions:</strong> We understand that no two taxpayers are alike. Our approach is highly 
            personalized, ensuring that your financial situation—whether simple or complex—is addressed with care.
          </p>
          <p className="tax-section-description">
            <strong>✔ Maximized Refunds & Credits:</strong> We actively search for every eligible deduction, credit, or 
            tax-saving opportunity to put more money back in your pocket.
          </p>
          <p className="tax-section-description">
            <strong>✔ End-to-End Support:</strong> From filing your federal 1040 form to handling multi-state and local 
            obligations, we provide seamless, all-in-one tax solutions for individuals, families, and professionals.
          </p>
          <p className="tax-section-description">
            Don’t let tax season overwhelm you. <em>Let us simplify the process, minimize risks, and maximize your benefits.</em> 
            Contact <strong>Litax </strong> today and experience a new level of professionalism in federal, 
            state, city, and county tax filing.
          </p>
        </div>
      </div>
      <Cosection />
      <Whatsapp />
      <ScrollTop />
      <Footer />
    </div>
  );
};

export default Federal;
